import React, { useState, useEffect } from 'react';
import { object, func, bool } from 'prop-types';

import { CloneObject } from '../../../utils/helpers';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import { useEntidad } from '../../hooks/useEntidad';
import { DatePickerCustom, FormLabel, Modal, Select, FormError } from '../../common';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { useFormErrors } from '../../hooks/useFormErrors';
import { isNull } from '../../../utils/validator';
import InputCustom from '../../common/InputCustom';
import { useLista } from '../../hooks/useLista';
import {TIPS} from "../../../consts/tips";


const VariableCuentaModal = (props) => {

  const entityInit = {
    id: 0,
    idCuenta: 0,
    idVariable: 0,
    valor: '',
    fechaDesde: null,
    fechaHasta: null
  };

  //hooks
  const [state, setState] = useState({
    entity: entityInit,
    showInfo: false
  });
  const [variable, setVariable] = useState({
    id: 0,
    codigo: '',
    descripcion: '',
    idTipoTributo: 0,
    tipoDato: '',
    constante: false,
    predefinido: false,
    opcional: true,
    activo: true,
    lista: ''
  });

  const mount = () => {
    setState(prevState => {
      return {...prevState, entity: props.data.entity };
    });
    formSet({
      valor: props.data.entity.valor,
      fechaDesde: props.data.entity.fechaDesde,
      fechaHasta: props.data.entity.fechaHasta
    });

    setVariable(props?.data?.definition)
  }
  useEffect(mount, [props.data.entity]);

  const [ getListLista, getRowLista, readyLista ] = useLista({
      listas: props?.data?.definition?.lista ? [props?.data?.definition?.lista] : null,
      onLoaded: (listas, isSuccess, error) => {
        if (isSuccess) {
        }
        else {
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
        } 
      },
      memo: {
        key: props?.data?.definition?.lista,
        timeout: 0
      }
  }); 

  const [ formValues, formHandle, , formSet ] = useForm({
    valor: '',
    fechaDesde: null,
    fechaHasta: null
  });

  const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);

  //handles
  const handleClickAceptar = () => {
    if (!validate()) return;

    const aviso = getAvisoSinCampo();
    if (aviso) {
      ShowToastMessage(ALERT_TYPE.ALERT_WARNING, aviso);
      return;
    }

    let row = CloneObject(state.entity);
    row.valor = formValues.valor;
    row.fechaDesde = formValues.fechaDesde;
    row.fechaHasta = formValues.fechaHasta;

    props.onConfirm(row);
  };

  //funciones
  function getErrors() {

    const errors = {};

    if (!variable.constante) {
      if (!isNull(formValues.fechaDesde) && !isNull(formValues.fechaHasta) && formValues.fechaDesde > formValues.fechaHasta) errors.fechaHasta = 'No puede ser anterior a la fecha desde';
    }
    if (formValues.valor.length <= 0) errors.valor = VALIDATION_MESSAGE.REQUIRED;

    return errors;
  }

  function getFormatErrors() {

    const errors = {};

    if (!variable.constante && esRangoSolapado()) errors.fechaDesde = 'El rango se superpone con otro';

    return errors;
  }

  function getAvisoSinCampo() {
    if (variable.constante && props.solapaOtroValor) return `La variable "${variable.descripcion}" es de tipo constante y tiene más de un registro cargado. Debe quedar uno solo.`;
    return null;
  }

  function esRangoSolapado() {
    const rango = props.rangoSolapado;
    return !isNull(rango)
        && sonLaMismaFecha(rango.fechaDesde, formValues.fechaDesde)
        && sonLaMismaFecha(rango.fechaHasta, formValues.fechaHasta);
  }

  function sonLaMismaFecha(una, otra) {
    if (isNull(una) || isNull(otra)) return isNull(una) && isNull(otra);
    return una.getTime() === otra.getTime();
  }

  return (
    <>

    <Modal
      size="lg"
      title={`Variable ${variable.codigo} (${variable.descripcion}) ${(state.entity.id > 0) ? "" : "(Nuevo valor)"}`}
      tipName={TIPS.NAME.MODALS.VARIABLE_CUENTA_MODAL}
      onEscape={() => props.onDismiss()}
      body={(
            <div className="row">
                
              {!variable.constante &&
              <>
              <div className="mb-3 col-4">
                  <label htmlFor="fechaDesde" className="form-label">Fecha desde</label>
                  <DatePickerCustom
                      name="fechaDesde"
                      placeholder=""
                      className={`form-control ${errorOf('fechaDesde') ? 'is-invalid' : ''}`}
                      value={ formValues.fechaDesde }
                      onChange={ formHandle }
                      disabled={props.disabled}
                  />
                  <FormError message={errorOf('fechaDesde')} />
              </div>

              <div className="mb-3 col-4">
                  <label htmlFor="fechaHasta" className="form-label">Fecha hasta</label>
                  <DatePickerCustom
                      name="fechaHasta"
                      placeholder=""
                      className={`form-control ${errorOf('fechaHasta') ? 'is-invalid' : ''}`}
                      value={ formValues.fechaHasta }
                      onChange={ formHandle }
                      disabled={props.disabled}
                      minValue={formValues.fechaDesde}
                  />
                  <FormError message={errorOf('fechaHasta')} />
              </div>
              </>
              }

            {variable.tipoDato !== 'list' ?
              <div className="mb-3 col-4">
                  <FormLabel htmlFor="valor" required>Valor</FormLabel>
                  <InputCustom
                      name="valor"
                      type={ variable.tipoDato }
                      placeholder=""
                      className="form-control"
                      value={ formValues.valor }
                      onChange={ formHandle }
                      disabled={props.disabled}
                      serialize={true}
                      invalid={!!errorOf('valor')}
                  />
                  <FormError message={errorOf('valor')} />
              </div>
              : 
              <div className="mb-3 col-4">
                <FormLabel htmlFor="valor" required>Valor</FormLabel>
                <Select
                  name="valor"
                  className={`form-control ${errorOf('valor') ? 'is-invalid' : ''}`}
                  value={ formValues.valor }
                  onChange={(event) => {
                    const {target} = event;
                    formSet({...formValues, valor: target.value});
                  }}
                  disabled={props.disabled}
                  options={getListLista(variable.lista).map(item => ({ value: item.codigo, label: item.codigo + ' - ' + item.nombre }))}
                />
                <FormError message={errorOf('valor')} />
              </div> 
            } 

            </div>
      )}
      footer={!props.disabled ? (<>
              <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Cancelar</button>
              <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
      </>) : (
              <button className="btn back-button" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
      )}
      footerClassName={props.disabled ? 'f-align' : ''}
    />

    </>
  );
}

VariableCuentaModal.propTypes = {
  disabled: bool,
  data: object.isRequired,
  rangoSolapado: object,
  solapaOtroValor: bool,
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
};

VariableCuentaModal.defaultProps = {
  disabled: false,
  rangoSolapado: null,
  solapaOtroValor: false
};

export default VariableCuentaModal;